import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import throttle from 'lodash.throttle';
import Url from '@music/mobile-url';
import * as WorksAction from './action/works';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import Topbar from '@music/ct-creator-topbar';
import History from './util/history';
import Spin from './component/spin';
import '@music/ct-creator-topbar/dist/index.css';
//views
import Footer from './footer';
import Aside from './aside';
/*
    来自朋友圈视频不展示左侧导航，url中传递from=friendvideo => 现在可以展示左侧导航了
*/
class Container extends Component{
    constructor(props) {
        super(props);
        this.params = Url.CurrentParams;
        this.state = {
            minHeight: 0,
            norHeight: 0,
            isSideForceShow: false
        };
        this.resize = throttle(this.resize.bind(this), 300);
    }
    resize(){
        this.calculateHeight();
    }
    calculateHeight(){
        let minHeight = document.documentElement.clientHeight;
        let other = 70 + 5 + 121;  //页头加页尾
        let wrapEle = document.getElementById('j-app-v2');
        let realHeight = wrapEle.clientHeight;
        //console.log(minHeight, realHeight);
        if(realHeight < minHeight){
            this.setState({
                minHeight: minHeight - other
            });
        }
    }
    onClickMenu = () => {
        this.refs.asideRef.show();
    }

    handleMenuClick = (show) => () => {
        let isSideForceShow;
        if(show != null){
            isSideForceShow = !!show;
        } else {
            isSideForceShow = !this.state.isSideForceShow;
        }   
        if(isSideForceShow !== this.state.isSideForceShow){
            this.setState({
                isSideForceShow
            });
        }         
    }
    componentDidMount(){
        this.calculateHeight();
        window.addEventListener('resize', self.resize, false);
    }
    componentWillUnmount(){
        window.removeEventListener('resize', this.resize, false);
    }
    render(){
        let {children, User} = this.props;
        let {minHeight, isSideForceShow} = this.state;
        let nfrom = this.params.from;
        let contNode;
        let hstyle;
        let asideNode = <Aside ref="asideRef" />;
        const { type, companyParticipateState } = User.cashEncourageState;
        if (type === 2 && companyParticipateState === 2) {
            asideNode = null;
        }
        if(minHeight > 0){
            hstyle = {'minHeight': minHeight + 'px'};
        }
        if(!User.data || !User.cashEncourageState){  // 用户基本信息和现金激励参与情况的数据必须有
            contNode = (
                <div className={`m-body g-bd n-video f-cb`}>
                    <div className="g-mnc m-loadonly">
                        <Spin />
                    </div>
                </div>
            )
        }
        else{

            contNode = (
                <div className={`m-body g-bd n-video f-cb`}>
                    {children}
                </div>
            )
        }
        return (
            <div className="g-doc">
                <Topbar onClickMenu={this.onClickMenu} />
                <div className="g-main">
                    {asideNode}
                    <div className={ asideNode ? `g-content g-mn` : 'g-noside-mn'}>
                        {contNode}
                        {/* <Footer /> */}
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(({User}) => ({User}))(Container);


// WEBPACK FOOTER //
// ./client/container.js